/**
 * Validates an given house number
 */
export default {
  methods: {
    houseNumberValidator (v) {
      const validator = /^(\d{1,5})$|^(\d{1,4}([a-zA-Z]))$|^(((\d{1,5})|(\d{1,4}([a-zA-Z])))-((\d{1,5})|(\d{1,4}([a-zA-Z]))||([a-zA-Z])))$/
      return validator.test(v)
    }
  }
}
